import { MutationKey, QueryKey } from '@tanstack/react-query';

export const matchesQueryKeys: QueryKey = ['matches', 'query'];
export const matchGetKeys: QueryKey = ['match', 'get'];

export const createMatchMutationKey: MutationKey = ['match', 'mutation', 'create'];
export const updateMatchMutationKey: MutationKey = ['match', 'mutation', 'update'];
export const deleteMatchMutationKey: MutationKey = ['match', 'mutation', 'delete'];
